export const AGENT_API_PATH = {
  UPDATE_AGENT_PERMISSIONS: "v1/organization/{0}/organization-user/{1}/",
  PERMISSIONS_CHANGE_VERIFICATION:
    "v1/organization/permission-change/verification/",
  DELETE_AGENT: "v1/organization-user",

  GET_AGENT_PRICING: (agentId: string): string =>
    `organization-user/${agentId}/organization-user-pricing/`,
  UPDATE_AGENT_PRICING: (agentId: string): string =>
    `organization-user/${agentId}/organization-user-pricing/update/`,
};

export const MAX_BULK_IMPORT_USERS = 200;
